import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de4e35945d6b7e/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e35945d6b7e/node_modules/next/dist/client/link.js");
